import React from "react";
import ReactApexChart from "react-apexcharts";

const SaudiFacultyPercentageChart = ({
  maleData = [],
  femaleData = [],
  categories = [],
  title = "نسبة هيئة التدريس السعوديين (ذكور وإناث)",
  colors = ["#2e86de", "#e84393"],
  height = 350,
}) => {
  const series = [
    {
      name: "ذكور",
      data: maleData,
    },
    {
      name: "إناث",
      data: femaleData,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      height: height,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "30%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val.toFixed(1)}%`,
      style: {
        fontSize: "12px",
        fontFamily: "Cairo",
      },
    },
    xaxis: {
      categories: categories,
      title: {
        text: "الجامعة",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}%`,
        style: {
          fontFamily: "Cairo",
        },
      },
      title: {
        // text: "النسبة المئوية",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
      min: 0,
      max: 100,
    },
    colors: colors.slice(0, 2),
    legend: {
      position: "top",
      horizontalAlign: "center",
      fontFamily: "Cairo",
    },
    tooltip: {
      y: {
        formatter: (val) => `${val.toFixed(1)}%`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3" style={{ fontFamily: "Cairo" }}>{title}</h5>
      <ReactApexChart options={options} series={series} type="bar" height={height} />
    </div>
  );
};

export default SaudiFacultyPercentageChart;
